/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_H1Inputs */

const en_guide_json_schema_h1 = /** @type {(inputs: Guide_Json_Schema_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema: Validate Your Data Structure`)
};

const ko_guide_json_schema_h1 = /** @type {(inputs: Guide_Json_Schema_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema: 데이터 구조 유효성 검사`)
};

const ja_guide_json_schema_h1 = /** @type {(inputs: Guide_Json_Schema_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema：データ構造を検証する`)
};

/**
* | output |
* | --- |
* | "JSON Schema: Validate Your Data Structure" |
*
* @param {Guide_Json_Schema_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_h1 = /** @type {((inputs?: Guide_Json_Schema_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_h1(inputs)
	if (locale === "ko") return ko_guide_json_schema_h1(inputs)
	return ja_guide_json_schema_h1(inputs)
});